import React, { useState } from 'react';
import styled from 'styled-components';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactTabs from 'shared/design-system/components/TrueImpactTabs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@fortawesome/pro-light-svg-icons';
import MatchTab from './MatchTab';
import TemplatesTab from './TemplatesTab';
import ResultsTab from './ResultsTab';
import FeedbackTab from './FeedbackTab';
import StatsTab from './StatsTab';

type TabValue = 'match' | 'templates' | 'results' | 'feedback' | 'stats';

const PageWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: ${SPACERS.large};
  box-sizing: border-box;
`;

const PageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACERS.small};
  margin-bottom: ${SPACERS.medium};
  flex-wrap: wrap;
  .header-icon {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: ${COLORS.ctaPrimaryBackground};
    color: ${COLORS.ctaPrimary};
  }
  .heading {
    margin: 0;
  }
  .subheading {
    margin: 2px 0 0;
    color: ${COLORS.grayDark};
  }
`;

const TabsWrapper = styled.div`
  margin-bottom: ${SPACERS.medium};
  border-bottom: 1px solid ${COLORS.greyLight};
  .modal-tab {
    padding-top: ${SPACERS.small};
  }
`;

const HafizAiAgent: React.FC = () => {
  const [tab, setTab] = useState<TabValue>('match');

  return (
    <PageWrapper>
      <PageHeader>
        <div className="header-icon">
          <FontAwesomeIcon icon={faRobot} size="lg" />
        </div>
        <div>
          <TrueImpactText variant="heading-page" className="heading">
            Hafiz's AI Agent
          </TrueImpactText>
          <TrueImpactText variant="body-small" className="subheading">
            Template matching agent — find, manage, and evaluate template
            matches.
          </TrueImpactText>
        </div>
      </PageHeader>

      <TabsWrapper>
        <TrueImpactTabs<TabValue>
          selectedValue={tab}
          handleChange={setTab}
          tabs={[
            { text: 'Match', value: 'match' },
            { text: 'Templates', value: 'templates' },
            { text: 'Results', value: 'results' },
            { text: 'Feedback', value: 'feedback' },
            { text: 'Stats', value: 'stats' },
          ]}
        />
      </TabsWrapper>

      {tab === 'match' && <MatchTab />}
      {tab === 'templates' && <TemplatesTab />}
      {tab === 'results' && <ResultsTab />}
      {tab === 'feedback' && <FeedbackTab />}
      {tab === 'stats' && <StatsTab />}
    </PageWrapper>
  );
};

export default HafizAiAgent;
